export function getScene(scene) {
    return scene
}

export function setScene(scene) {
    this.scene = scene;
}
